import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Signal,
  inject,
  InputSignal,
  input,
} from '@angular/core';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { Capacitor } from '@capacitor/core';
import { Router } from '@angular/router';
import { ButtonComponent, ModalHeaderComponent } from '@lyceo/shared/ui';
import { ModalController } from '@ionic/angular/standalone';
import { FEEDBACK_CONFIG, FeedbackConfig } from '@lyceo/shared/feedback/util';

@Component({
  selector: 'lyceo-feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss'],
  imports: [ButtonComponent, ModalHeaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeedbackModalComponent {
  private readonly feedbackConfig: FeedbackConfig =
    inject<FeedbackConfig>(FEEDBACK_CONFIG);
  private readonly authFacade: AuthFacade = inject(AuthFacade);
  private readonly router: Router = inject(Router);
  private readonly modalController: ModalController = inject(ModalController);

  public readonly modalTitle: InputSignal<string> = input.required();
  public readonly modalBodyText: InputSignal<string> = input.required();
  public readonly modalButtonText: InputSignal<string> = input.required();

  protected email: string = this.feedbackConfig.email;
  protected readonly mailToQueryParams: Signal<string> = computed(() => {
    let params: string = `subject=Mijn feedback over de ${this.feedbackConfig.name} release `;
    params += `${this.feedbackConfig.release} (${this.platform})&body=`;
    //%0D%0A for line breaks works for Outlook, %0D does not
    params += `%0D%0A%0D%0A%0D%0A%0D%0A%0D%0A----%0D%0A%0D%0A`;
    params += `${this.userName()} - ${this.userEmail()}%0D%0A`;
    if (this.pageId) {
      params += `Pagina: ${this.pageId}%0D%0A`;
    }
    params += `${this.feedbackConfig.name} release ${this.feedbackConfig.release} (${this.platform})`;

    return params;
  });

  private readonly userName: Signal<string | undefined> =
    this.authFacade.userFullName;
  private readonly userEmail: Signal<string | undefined> =
    this.authFacade.userEmail;
  private readonly platform: string;
  private readonly pageId: string;

  constructor() {
    this.platform = Capacitor.getPlatform();
    this.pageId = this.router.url.slice(1);
  }

  public close(): void {
    this.modalController.dismiss();
  }
}
